<template>
  <div class="center-base all" style="min-height: 400px;">
    <ConfirmCustomer v-if="u === 'c'" :ck="ck" :u="u" />
    <ConfirmGuider v-if="u === 'g'" :ck="ck" :u="u" />
  </div>
</template>

<script>
// external dependencies

// custom component
import ConfirmCustomer from '@/components/ConfirmCustomer'
import ConfirmGuider from '@/components/ConfirmGuider'

// api call

export default {
  name: 'ConfirmationEmail',
  props: [
    'u', // user type (customer/guider)
    'ck' // confirmation key
  ],
  components: {
    ConfirmCustomer,
    ConfirmGuider
  },
  mounted: function () {
    if ((this.u !== 'c' && this.u !== 'g') || !this.ck) {
      this.$router.push({ name: 'PageNotFound' })
    }
  },
  methods: {
    // PREREQUISITES
    // END PREREQUISITES

    // HTTP REQUEST
    // END HTTP REQUEST
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/ConfirmationEmail.vue